var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTypeRefTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 30C13.45 30 12.9792 29.8042 12.5875 29.4125C12.1958 29.0208 12 28.55 12 28V14C12 13.45 12.1958 12.9792 12.5875 12.5875C12.9792 12.1958 13.45 12 14 12H28C28.55 12 29.0208 12.1958 29.4125 12.5875C29.8042 12.9792 30 13.45 30 14V28C30 28.55 29.8042 29.0208 29.4125 29.4125C29.0208 29.8042 28.55 30 28 30H14ZM14 17.325H28V14H14V17.325ZM14 22.675H28V19.325H14V22.675ZM14 28H28V24.675H14V28ZM15 16.65V14.65H17V16.65H15ZM15 22V20H17V22H15ZM15 27.35V25.35H17V27.35H15Z",
    fill: "#EBEDF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTypeRefTable);
export default __webpack_public_path__ + "807020fa82211d98d5257dcde04c6d18.svg";
export { ForwardRef as ReactComponent };